import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "product-scanner"
  // Which surface opened the scanner ("onboarding", "routine", or
  // "shelf_drawer"). The native component tags every event of the session
  // with it, so the entry points stay separable in analytics.
  static values = { mode: { type: String, default: "onboarding" } }

  connect() {
    super.connect()

    // Dismissing the native scanner always makes Hotwire Native re-visit this
    // page with a Turbo restore, which re-renders it: this controller is
    // recreated, its reply callbacks are dropped, and the button's disabled
    // state comes back baked into the snapshot. Reset the button so the
    // scanner can always be reopened, and collect any finished session's
    // products here — this is the page instance that survives the restore, so
    // whatever it renders sticks.
    this.element.disabled = false
    this.send("results", {}, message => this.handleResults(message))
  }

  present(event) {
    event.preventDefault()

    this.element.disabled = true
    // The reply is only an acknowledgement (status, no products). If the
    // restore renders after the scanner is dismissed, this instance is about
    // to be thrown away along with anything it renders, so products are never
    // delivered through it — see connect().
    this.send("present", { mode: this.modeValue }, () => {
      this.element.disabled = false
    })
  }

  handleResults(message) {
    // The search fallback also returns products scanned before the user chose
    // search, so preserve the native status and let each surface decide whether
    // those products should be committed or held for its search flow.
    const data = message.data
    if (!data?.products?.length) return

    // Guard this instance against a repeated reply for the same session. The
    // guard is per instance on purpose: a recreated controller means the page
    // was re-rendered and the previous delivery is gone, so it must render
    // the products again.
    if (data.session_id && data.session_id === this.lastDeliveredSessionId) return
    this.lastDeliveredSessionId = data.session_id

    this.dispatch("completed", {
      detail: { status: data.status, products: data.products },
      bubbles: true
    })
  }
}
